import { AppNav } from 'src/routes/app-nav';
import {Injectable} from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { UserService } from '@/services/user.service';
import { UserDTO } from '@/classes/userDTO';

@Injectable()
export class RoleGuard  {
  private user? : UserDTO

  constructor(
    private router: Router,
    private userService : UserService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRole = route.data.expectedRole;
    this.userService.initialize$();
    this.userService.getLoggedInUser().subscribe(x=> this.user = x);
    const roles: string[] | undefined = this.user?.userRoles;

    if (!roles?.includes(expectedRole)) {
      this.router.navigateByUrl('/' + AppNav.QueryInvoices.route);
      return false;
    }

    return true;
  }
}